<div class="flex flex-col items-center justify-center h-full text-center">
    <fa-icon
        class="py-4 text-custom-blue"
        [icon]="['fal', 'circle-exclamation']"
        [size]="iconSize()" />
    <span [class]="[textSize(), textWidth()]">{{ displayedMessage() | transloco }}</span>
    @if (information()) {
        <p
            class="py-3 text-xl"
            [class]="textWidth()">
            {{ information() | transloco }}
        </p>
    }
</div>
